import Button from '@/components/Button/Button';

export const AchievementsUsersPage = () => {
  return (
    <div className="flex flex-col items-start justify-start space-y-4 p-4">
      {/* ボタン群 */}
      <div className="flex flex-row space-x-4">
        <Button
          size="lg"
          variant="solid-fill"
          onClick={() => console.log('本日の利用者')}
        >
          本日の利用者
        </Button>
        <Button
          size="lg"
          variant="solid-fill"
          onClick={() => console.log('全利用者')}
        >
          全利用者
        </Button>
        <Button
          size="lg"
          variant="solid-fill"
          onClick={() => console.log('来所予約')}
        >
          来所予約
        </Button>
        <Button
          size="lg"
          variant="solid-fill"
          onClick={() => console.log('送迎予約一覧')}
        >
          送迎予約一覧
        </Button>
        <Button
          size="lg"
          variant="solid-fill"
          onClick={() => console.log('夕食予約一覧')}
        >
          夕食予約一覧
        </Button>
      </div>
    </div>
  );
};

export default AchievementsUsersPage;
